import { showError } from "./toastUtils";

const humanizeMessage = (msg = "") => {
  return msg
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (l) => l.toUpperCase());
};

export const handleApiValidationError = (err, setErrors) => {
  let backendErrors = err?.response?.data;

  if (backendErrors.label === "DEVELOPMENT ERROR") {
    backendErrors = backendErrors?.error;
  }

  if (Array.isArray(backendErrors.details)) {
    const fieldErrors = {};

    backendErrors.details.forEach((e) => {
      fieldErrors[e.field] = humanizeMessage(e.message);
    });

    setErrors(fieldErrors);
    showError("Please fix the highlighted errors");
    return true;
  }
  
  const fieldErrors = {};
  fieldErrors["general"] = humanizeMessage(err?.response?.data?.message);
  setErrors(fieldErrors);
  showError(err?.response?.data?.message || "Something went wrong");
  return false;
};
